<script lang="ts" setup>
interface Props {
  dataTestid?: string;
  type: string;
  name: string;
  fw?: boolean;
  size?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
  dataTestid: 'icon',
  fw: true,
  size: '',
});

const classes = [
  'zo-icon',
  `${props.type} fa-${props.name}`,
];

if (props.fw) {
  classes.push('fa-fw');
}

if (props.size) {
  const prefix = 'fa';
  const initial = props.size ? `${prefix}-${props.size}` : '';
  classes.push(parseInt(initial, 10) > 0 ? `${prefix}-${props.size}x` : initial);
}
</script>

<template>
  <span
    :class="classes"
    :data-testid="dataTestid"
  />
</template>

<style lang="scss">
.zo-icon {
  color: var(--icon-color, currentColor);
  mix-blend-mode: var(--icon-blend-mode, normal);
}
</style>
